import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: Home
  },

  // 首页
  {
    path: '/home',
    name: 'Home',
    component: Home
  },

  // 关于我们
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: () => import("../views/aboutUs/AboutUs.vue")
  },

  // 业务板块
  {
    path: '/businessUnit',
    name: 'BusinessUnit',
    component: () => import("../views/businessUnit/BusinessUnit.vue")
  },

  // 动态资讯
  {
    path: '/dynamicInformation',
    name: 'DynamicInformation',
    component: () => import("../views/dynamicInformation/DynamicInformation.vue")
  },

  // 联系我们
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import("../views/contactUs/ContactUs.vue")
  },

  // 视频教学
  {
    path: '/videoPage',
    name: 'VideoPage',
    component: () => import("../views/dynamicInformation/detailPage/VideoPage.vue")
  },

  // 培训
  {
    path: '/training',
    name: 'Training',
    component: () => import("../views/training/Training.vue")
  },








  // 行业资讯
  {
    path: '/informationOne',
    name: 'InformationOne',
    component: () => import("../views/dynamicInformation/detailPage/InformationOne.vue")
  },
  {
    path: '/informationTwo',
    name: 'InformationTwo',
    component: () => import("../views/dynamicInformation/detailPage/InformationTwo.vue")
  },
  {
    path: '/informationThree',
    name: 'InformationThree',
    component: () => import("../views/dynamicInformation/detailPage/InformationThree.vue")
  },
  {
    path: '/informationFour',
    name: 'InformationFour',
    component: () => import("../views/dynamicInformation/detailPage/InformationFour.vue")
  },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router
